import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/package/availability';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  getPackageTagsSearchOptions,
  getIsFetchingPackageTagsOptions,
  getPackageAvailabilityLocationsOptions,
  getIsFetchingPackageAvailabilityLocationsOptions
} from '../../../redux/Inventory/selectors/components/search-options';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Inventory/actions/components/search';
import { clearInventoryPackagesAvailability } from '../../../redux/Inventory/actions/package';
import {
  fetchInventoryPackagesAvailability,
  fetchInventoryPackageTagsOptions,
  fetchInventoryPackageAvailabilityLocationOptions
} from '../../../redux/Inventory/sagas/routines';
import AvailabilitySearch from '../../../components/inventory/AvailabilitySearch';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.PACKAGE_AVAILABILITY
  );
  return {
    ...props,
    searchQuery,
    tagsOptions: getPackageTagsSearchOptions(state),
    locationOptions: getPackageAvailabilityLocationsOptions(state),
    isFetching: getIsFetching(state),
    isFetchingTagsOptions: getIsFetchingPackageTagsOptions(state),
    isFetchingLocationOptions: getIsFetchingPackageAvailabilityLocationsOptions(
      state
    )
  };
}

function mapDispatchToProps(dispatch) {
  const context = SEARCH_CONTEXT.PACKAGE_AVAILABILITY;
  return {
    onInit: () => {
      dispatch(fetchInventoryPackageTagsOptions());
      dispatch(fetchInventoryPackageAvailabilityLocationOptions());
    },
    onSubmit: queryOptions => {
      dispatch(clearInventoryPackagesAvailability());
      dispatch(fetchInventoryPackagesAvailability(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context, query }));
    },
    onClear: () => {
      dispatch(onClearQuery({ context }));
      dispatch(clearInventoryPackagesAvailability());
      dispatch(fetchInventoryPackagesAvailability({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilitySearch);
